import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import TopPage from './pages/TopPage';
import SharedTopPage from './pages/SharedTopPage';
import AccessoryPage from './pages/AccessoryPage';
import PartyManagementPage from './pages/PartyManagementPage';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#60a5fa' }, // Neon/modern blue
    secondary: { main: '#c084fc' }, // Modern purple
    background: { default: '#0f172a', paper: '#1e293b' },
    text: { primary: '#f8fafc', secondary: '#cbd5e1' },
    divider: 'rgba(255, 255, 255, 0.12)',
  },
  typography: {
    fontFamily: '"Inter", "Noto Sans JP", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Helmet>
          <title>ティンクルスターナイツ ライブラリ</title>
          <meta name="description" content="ティンクルスターナイツの所持・装飾品・編成管理ツール" />
        </Helmet>

        <Header />
        <Switch>
          <Route path="/" exact component={TopPage} />
          <Route path="/shared" component={SharedTopPage} />
          <Route path="/accessories" component={AccessoryPage} />
          <Route path="/partymanagement" component={PartyManagementPage} />
        </Switch>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}
